import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TopHeadding from "../../components/layout/TopHeadding";
import plus_icon from "../../assets/images/plus_icon.svg";
import FormulaListTable from "../../components/tables/FormulaListTable";
import FormulaDetailPopup from "../../components/popups/FormulaDetailPopup";
import DeletePopup from "../../components/popups/DeletePopup";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { fetchAllFormulas, deleteFormula } from "../../store/slices/formulaSlice";

const Formula = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user, role } = useAppSelector((state) => state.user);
  const { formulaList, loading, totalRecords } = useAppSelector(
    (state) => state.formula || {}
  );

  const [filters] = useState({
    startDate: null,
    endDate: null,
    payRange: [0, 1000000],
    status: true
  });

  useEffect(() => {
    if (!user?.id) return;

    const timeout = setTimeout(() => {
      const params = {
        pageIndex: page - 1,
        pageSize: pageSize,
        startDate: filters.startDate ?? null,
        endDate: filters.endDate ?? null,
        isActive: filters.status,
        minPayAvg: filters.payRange[0],
        maxPayAvg: filters.payRange[1],
      };
      if (search) {
        params.search = search;
      }
      if (search) params.search = search;
      if (role === "Client" || role === "Company") params.userId = user.id;
      dispatch(
        fetchAllFormulas(params)
      );
    }, 400);

    return () => clearTimeout(timeout);
  }, [search, dispatch, user, role, page, filters]);

  // modal state
  const [showDetail, setShowDetail] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleView = (item) => {
    setSelectedItem(item);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedItem(null);
  };

  const handleEdit = (item) => {
    navigate(`/addnewformula`, {
      state: { id: item.id },
    });
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (selectedItem?.id) {
      dispatch(deleteFormula(selectedItem.id));
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  return (
    <div className="Companies">
      <TopHeadding
        title={`Formulas`}
        subtitle=" "
        showDatepicker={false}
        buttons={[
          {
            text: "Add Formula",
            className: "btn_primary",
            icon: plus_icon,
            onClick: () => navigate("/addnewformula"),
          },
        ]}
        showSearch={true}
        onSearch={setSearch}
      />

      <div className="clint_table mt_30">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="white_box py_20 px_20">
                {/* <FilterTopBar
                  title="Formulas"
                  count={totalRecords}
                  search={search}
                  onSearchChange={setSearch}
                  placeholder="Search formulas"
                  showExport={false}
                  onFilterChange={setFilters}
                /> */}

                <div className="pt_6">
                  {loading ? (
                    <div className="p-4 text-center text-muted">Loading</div>
                  ) : formulaList.length > 0 ? (
                    <FormulaListTable
                      data={formulaList}
                      onView={handleView}
                      onEdit={handleEdit}
                      onDelete={handleDelete}
                      currentPage={page}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={(pageNumber) => setPage(pageNumber)}
                    />
                  ) : (
                    <div className="p-4 text-center text-muted">No Data Found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Detail modal */}
      <FormulaDetailPopup
        show={showDetail}
        handleClose={handleCloseDetail}
        item={selectedItem}
      />

      <DeletePopup
        show={showDeleteModal}
        type="Formula"
        handleClose={() => setShowDeleteModal(false)}
        onDelete={confirmDelete}
        allowedNames={selectedItem ? [selectedItem.name] : []}
      />
    </div>
  );
};

export default Formula;
